__turbopack_context__.v({
  "metaBlock": "llm-component-schema-module__-maxYG__metaBlock",
  "metaGrid": "llm-component-schema-module__-maxYG__metaGrid",
  "metaLabel": "llm-component-schema-module__-maxYG__metaLabel",
  "metaLeft": "llm-component-schema-module__-maxYG__metaLeft",
  "metaOverview": "llm-component-schema-module__-maxYG__metaOverview",
  "metaRight": "llm-component-schema-module__-maxYG__metaRight",
  "metaSection": "llm-component-schema-module__-maxYG__metaSection",
  "metaText": "llm-component-schema-module__-maxYG__metaText",
  "metaTools": "llm-component-schema-module__-maxYG__metaTools",
  "page": "llm-component-schema-module__-maxYG__page",
  "pipelineCaption": "llm-component-schema-module__-maxYG__pipelineCaption",
  "pipelineDiagram": "llm-component-schema-module__-maxYG__pipelineDiagram",
  "pipelineSvg": "llm-component-schema-module__-maxYG__pipelineSvg",
  "schemaExample": "llm-component-schema-module__-maxYG__schemaExample",
});
